import { UserData } from '../../types/api';
import { Serializable } from '../lib/Serializable';

type SerializeUserData = UserData & {
  timestamp: number;
};

export class User implements Serializable<SerializeUserData> {
  protected readonly data: UserData;
  created = Date.now();
  invalidReason = '';

  constructor(data: UserData) {
    this.data = data;
  }

  get<K extends keyof UserData>(key: K): UserData[K] {
    return this.data[key];
  }

  serialize(): SerializeUserData {
    return {
      ...this.data,
      timestamp: this.created,
    };
  }

  validate() {
    if (this.data === null) {
      this.invalidReason = 'Error during login';
      return false;
    }

    const { subscriptionStatus } = this.data;
    if (!['EXPIRED', 'ACTIVE', 'CLOSED'].includes(subscriptionStatus)) {
      this.invalidReason = 'Subscription status not allowed to login';
      return false;
    }

    return true;
  }
}
